export enum MovementPlanStatus {
  ACTIVE='ACTIVE', CANCELED='CANCELED', STARTED='STARTED', FINISHED='FINISHED'
}
